import { gql } from "apollo-boost";

const CREATE_BOUNDARY = gql`
  mutation createBoundary($boundary: String!) {
    create_boundary(boundary: $boundary) {
      analytics_data {
        user_id
        user_type
        flow
      }
    }
  }
`;

export default CREATE_BOUNDARY;
